import React from 'react';
import { Box, Typography } from '@mui/material';
import './PayoutOverview.css';
import DocumentLogo from '../../../../../assets/Admin/document-logo.svg';
import { getDocumentViewHref } from '../../../../../utils/documentUtils';

// This component mirrors OrganizationOverview but simplified for payout details.
// It expects a `teacher` object with profile and earnings fields.
const PayoutOverview = ({ teacher }) => {
  if (!teacher) return null;

  console.log(teacher);

  return (
    <Box className="payout-overview-container">
      <Box className="payout-overview-scroll">
        <Typography className="payout-overview-section-title">Wallet Information</Typography>
        <Box className="payout-overview-wallet-section">
          <Box className="payout-overview-wallet-card payout-overview-wallet-card--primary">
            <Typography className="payout-overview-wallet-card-title--primary">
              Total Earning
            </Typography>
            <Typography className="payout-overview-wallet-card-value">
              {teacher.totalEarning ?? 0} Riyal
            </Typography>
          </Box>
          <Box className="payout-overview-wallet-card">
            <Typography className="payout-overview-wallet-card-title">Locked Earning</Typography>
            <Typography className="payout-overview-wallet-card-value-muted">
              {teacher.lockedEarning ?? 0} Riyal
            </Typography>
          </Box>
          <Box className="payout-overview-wallet-card">
            <Typography className="payout-overview-wallet-card-title">Total Withdrawal</Typography>
            <Typography className="payout-overview-wallet-card-value-muted">
              {teacher.totalWithdrawal ?? 0} Riyal
            </Typography>
          </Box>
          <Box className="payout-overview-wallet-card">
            <Typography className="payout-overview-wallet-card-title">
              Payout Amount Requested
            </Typography>
            <Typography className="payout-overview-wallet-card-value-success">
              {teacher.requestedAmount ?? 0} Riyal
            </Typography>
          </Box>
        </Box>

        <Box className="payout-overview-section">
          <Typography className="payout-overview-section-title">Basic Information</Typography>
          <Box className="payout-overview-grid">
            <Box className="payout-overview-item">
              <Typography className="payout-overview-label">Name</Typography>
              <Typography className="payout-overview-value">{teacher.name || '---'}</Typography>
            </Box>
            <Box className="payout-overview-item">
              <Typography className="payout-overview-label">Email</Typography>
              <Typography className="payout-overview-value">{teacher.email || '---'}</Typography>
            </Box>
            <Box className="payout-overview-item">
              <Typography className="payout-overview-label">Phone Number</Typography>
              <Typography className="payout-overview-value">{teacher.phone || '---'}</Typography>
            </Box>
            <Box className="payout-overview-item">
              <Typography className="payout-overview-label">Address</Typography>
              <Typography className="payout-overview-value">{teacher.address || '---'}</Typography>
            </Box>
            <Box className="payout-overview-item">
              <Typography className="payout-overview-label">Current Location</Typography>
              <Typography className="payout-overview-value">
                {(() => {
                  const city = teacher.city;
                  const country = teacher.country;
                  if (city && country && city !== country) {
                    return `${city}, ${country}`;
                  }
                  if (city) {
                    return city;
                  }
                  if (country) {
                    return country;
                  }
                  return '---';
                })()}
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box className="payout-overview-section">
          <Typography className="payout-overview-section-title">Bank Information</Typography>
          <Box className="payout-overview-grid">
            <Box className="payout-overview-item">
              <Typography className="payout-overview-label">Bank Name</Typography>
              <Typography className="payout-overview-value">{teacher.bankName || '---'}</Typography>
            </Box>
            <Box className="payout-overview-item">
              <Typography className="payout-overview-label">IBAN Number</Typography>
              <Typography className="payout-overview-value">{teacher.iban || '---'}</Typography>
            </Box>
            <Box className="payout-overview-item">
              <Typography className="payout-overview-label">Bank Statement</Typography>
              <Box className="flex items-center gap-2">
                {/* Document Logo */}
                <img src={DocumentLogo} alt="Document" className="w-[18px] h-[18px]" />

                {/* Document Name */}
                <Typography className="payout-overview-value">
                  {teacher.bankStatement ? 'Bank Statement.pdf' : 'No document uploaded'}
                </Typography>

                {/* View Button */}
                {teacher.bankStatement && (
                  <a
                    href={getDocumentViewHref(teacher.bankStatement)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="view-button"
                    style={{
                      color: '#007bff',
                      textDecoration: 'none',
                      fontSize: '14px',
                      fontWeight: '500',
                      cursor: 'pointer',
                    }}
                  >
                    View
                  </a>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default PayoutOverview;
